import React, { useState } from 'react';
import { beforeAfterGallery } from '../mock';

const SliderHandle = ({ position }) => (
  <div
    className="absolute top-0 bottom-0 w-1 bg-white shadow-lg pointer-events-none"
    style={{ left: `${position}%` }}
  >
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-full w-8 h-8 flex items-center justify-center shadow-xl">
      <svg className="w-4 h-4 text-slate-900" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
      </svg>
    </div>
  </div>
);

const ComparisonImage = ({ item, position, onChange }) => (
  <div className="relative h-64 overflow-hidden">
    <div className="absolute inset-0">
      <img src={item.after} alt="After" className="w-full h-full object-cover" />
    </div>
    <div
      className="absolute inset-0"
      style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
    >
      <img src={item.before} alt="Before" className="w-full h-full object-cover" />
    </div>
    <div className="absolute inset-0 flex items-center">
      <input
        type="range"
        min="0"
        max="100"
        value={position}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
        className="w-full h-full opacity-0 cursor-ew-resize z-10"
      />
      <SliderHandle position={position} />
    </div>
    <div className="absolute top-4 left-4 bg-slate-900/80 backdrop-blur-sm text-white px-3 py-1 rounded-md text-sm font-semibold">
      Before
    </div>
    <div className="absolute top-4 right-4 bg-blue-600/90 backdrop-blur-sm text-white px-3 py-1 rounded-md text-sm font-semibold">
      After
    </div>
  </div>
);

const ComparisonCard = ({ item, position, onPositionChange }) => (
  <div
    data-testid={`gallery-item-${item.id}`}
    className="bg-white rounded-xl overflow-hidden border border-slate-200 shadow-md hover:shadow-xl transition-all duration-300"
  >
    <ComparisonImage item={item} position={position} onChange={onPositionChange} />
    <div className="p-6">
      <h3 className="text-xl font-bold text-slate-900 mb-2">{item.title}</h3>
      <p className="text-slate-600">{item.description}</p>
    </div>
  </div>
);

const BeforeAfterSection = () => {
  const [comparisons, setComparisons] = useState(beforeAfterGallery.map(() => 50));

  const handleSliderChange = (index, value) => {
    setComparisons((prev) => prev.map((v, i) => (i === index ? value : v)));
  };

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-blue-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Our Portfolio
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Projects & Before/After
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Drag the slider on each image to see the transformation — quality work that speaks for itself
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {beforeAfterGallery.map((item, index) => (
            <ComparisonCard
              key={item.id}
              item={item}
              position={comparisons[index]}
              onPositionChange={(value) => handleSliderChange(index, value)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
